<main class="main-dashboard">
  <article class="main-canvas">
    <section class="canvas-container">
      <section class="dashboard-items">
        <div class="canvas-item">
          <div class="canvas-header row justify-content-between align-items-center" >
            <div class="title col-sm-6">
              <div class="d-flex align-items-center">
                <div class="edit">
                  <button (click)="backToMyProject()">
                  <span><i class="ri-arrow-left-line"></i></span>
                  </button>
                </div>
                <h3 class="px-3">My Project</h3>
              </div>
            </div>
          </div>
          <div class="canvas-header row justify-content-between align-items-center">
            <div class="title col-sm-6 d-flex">
              <h3><a (click)="this.currentProjectId && openProjectTab('sub-project')" class="active">Sub-Project</a></h3>
              <h3><a (click)="this.currentProjectId && openProjectTab('issues')"> Issues</a></h3>
              <h3><a (click)="this.currentProjectId && openProjectTab('task')"> Tasks</a></h3>
              <h3><a (click)="this.currentProjectId && openProjectTab('resources')"> Resources</a></h3>
            </div>
          </div>
          
          <div class="canvas-data">
            <form [formGroup]="subProjectForm">
              <div class="row">
                <div class="col-sm-4 mb-2">
                  <div class="input">
                    <div class="input-item">
                      <input type="text" value="{{parentProjectName}}" disabled id="projectName"/>
                      <label class="floating-label-special">Parent Project*</label>
                      <i class="ri-file-list-line"></i>
                    </div>
                  </div>
                </div>
                <div class="col-sm-4 mb-2">
                  <div class="input">
                    <div class="input-item">
                      <input type="text" formControlName="projectName" id="projectName"/>
                      <label class="floating-label">Sub-Project Name*</label>
                      <i class="ri-file-list-line"></i>
                    </div>
                  </div>
                </div>
                <div class="col-sm-4 mb-2">
                  <div class="input">
                    <div class="input-item">
                      <input type="text" formControlName="projectCode"  id="projectCode" />
                      <label class="floating-label">Sub-Project code*</label>
                      <i class="ri-hashtag"></i>
                    </div>
                  </div>
                </div>
                <div class="col-sm-4 mb-2">
                  <div class="input">
                    <div class="input-item">
                      <input
                        list="taskOwnerDatalist"
                        formControlName="projectManager"
                        />
                      <label class="floating-label">Project Manager*</label>
                      <datalist id="taskOwnerDatalist">
                        <option
                          [value]="item"
                          *ngFor="let item of userDropdownList"
                        ></option>
                      </datalist>
                      <i class="ri-user-2-line"></i>
                    </div>
                    <mat-error *ngIf="f.projectManager.touched && f.projectManager.invalid" class="alert alert-danger">
                      <mat-error *ngIf="f.projectManager.errors.required">Project Manager is required</mat-error>
                    </mat-error>
                  </div>
                </div>
                <div class="col-sm-4 mb-2">
                  <div class="input">
                    <div class="input-item">
                      <input type="date" formControlName="startDate" id="startDate"  />
                      <label class="floating-label">Start Date*</label>
                      <i class="ri-calendar-check-line"></i>
                    </div>
                  </div>
                  <mat-error *ngIf="f.startDate.touched && f.startDate.invalid" class="alert alert-danger">
                    <mat-error *ngIf="f.startDate.errors.required">Start Date is required</mat-error>
                  </mat-error>
                </div>
                <div class="col-sm-4 mb-2">
                  <div class="input">
                    <div class="input-item">
                      <input type="date" formControlName="endDate" id="endDate"/>
                      <label class="floating-label">End Date</label>
                      <i class="ri-calendar-check-line"></i>
                    </div>
                  </div>
                </div>
                <div class="col-sm-4 mb-2">
                  <div class="input">
                    <div class="input-item">
                      <input type="date" formControlName="decisionDate" ng-model="valid"/>
                      <label class="floating-label">Decision Date</label>
                      <i class="ri-calendar-check-line"></i>
                    </div>
                  </div>
                </div>
                <div class="col-sm-4 mb-2">
                  <div class="input">
                    <div class="input-item">
                        <select formControlName="projectStatus" placeholder="Project Status">
                          <option value="" disabled selected>Project Status</option>
                          <option value="Active">Active</option>
                          <option value="On hold">On hold</option>
                          <option value="Archive">Archive</option>
                        </select>
                        <label for="status" class="floating-label-special">Project Status</label>
                      <i class="ri-inbox-archive-line"></i>
                    </div>
                  </div>
                </div>
                <div class="col-sm-4 mb-2">
                  <div class="input">
                    <div class="input-item">
                      <input type="text" disabled="true" formControlName="createdBy" />
                      <label class="floating-label-special">Created By</label>
                      <i class="ri-user-line"></i>
                    </div>
                  </div>
                </div>
                <div class="col-sm-4 mb-2">
                  <div class="input">
                    <div class="input-item">
                      <!-- <input type="text" formControlName="projectController" id="projectController" />
                      <label class="floating-label floating-label-special">Project controller*</label> -->
                      <input
                            list="taskOwnerDatalist"
                            formControlName="projectController"
                            />
                            <label class="floating-label">Project Lead Engineer*</label>
                          <datalist id="taskOwnerDatalist">
                            <option
                              [value]="item"
                              *ngFor="let item of userDropdownList"
                            ></option>
                          </datalist>
                      <i class="ri-user-follow-line"></i>
                    </div>
                    <mat-error *ngIf="f.projectController.touched && f.projectController.invalid" class="alert alert-danger">
                      <mat-error *ngIf="f.projectController.errors.required">Lead Engineer is required</mat-error>
                    </mat-error>
                  </div>
                </div>
                <div class="col-sm-4 mb-2">
                  <div class="input">
                    <div class="input-item">
                      <input type="text" formControlName="customer" id="customer"/>
                      <label class="floating-label floating-label-special">Customer</label>
                      <i class="ri-group-line"></i>
                    </div>
                  </div>
                </div>
                <div class="col-sm-4 mb-2">
                  <div class="input">
                    <div class="input-item">
                      <input type="number" min="0" max="1000" step="1" formControlName="totalHours" />
                      <label class="floating-label">Total Hours</label>
                      <i class="ri-time-fill"></i>
                    </div>
                  </div>
                </div>
                <div class="col-sm-4 mb-2">
                  <div class="input">
                    <div class="input-item">
                      <input type="number" min="0" max="1000" step="1" formControlName="remainingHours" />
                      <label class="floating-label">Remaining Hours</label>
                      <i class="ri-time-line"></i>
                    </div>
                  </div>
                </div>
                <div class="col-sm-4 mb-2">
                  <div class="input">
                    <div class="input-item">
                      <input type="number" min="0" max="1000" step="1" formControlName="percentWorkCompleted" />
                      <label class="floating-label">% of Project Completion</label>
                      <i class="ri-progress-2-line"></i>
                    </div>
                  </div>
                </div>
                <div class="col-sm-12 mb-2">
                  <div class="input">
                    <div class="input-item">
                      <textarea
                            name=""
                            id=""
                            cols="20"
                            rows="4"
                            formControlName="projectDescription"
                          ></textarea>
                      <label class="floating-label">Project description</label>
                      <i class="ri-file-list-3-line"></i>
                    </div>
                  </div>
                </div>
                <!-- <div class="row justify-content-end align-items-center" *ngIf="this.isPMOLeadORManager">
                  <div class="col-sm-12 text-end px-3 py-1">
                    <div class="d-flex justify-content-end gap-2">
                      <button class="btn-secondary btn" (click)="backToMyProject()">Cancel</button>
                      <div *ngIf="!this.currentProjectId">
                        <button type="button" class="btn" (click)="createSubProject()">Submit</button>
                      </div>
                      <div *ngIf="this.currentProjectId">
                        <button type="button" class="btn" (click)="updateSubProject()">Save</button>
                      </div>
                    </div>
                  </div>
                </div> -->

                <div class="row justify-content-end align-items-center">
                  <div class="d-flex gap-2 justify-content-end">
                    <button class="btn-secondary btn" (click)="backToMyProject()">Cancel</button>
                    <div *ngIf="this.isPMOLeadORManager"><a class="btn" (click)="updateSubProject()" *ngIf="this.currentProjectId">Save</a></div>
                    <a class="btn" (click)="createSubProject()" *ngIf="!this.currentProjectId">Submit</a>
                  </div>
                </div>

              </div>
            </form>
          </div>
        </div>
      </section>
    </section>
  </article>
</main>
